import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Web3 from "web3";
import UiButton from "../button";

import DateTimePicker from "react-datetime-picker";
import Loader from "../loader";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { format } from "date-fns";
import { toast } from "react-toastify";
import ERC20ABI from "../../utils/abi/ERC20.json";
import { useGlobal } from "../../context/globalContext";
import {
  FailureToast,
  SuccessToast,
  ToastOptions,
} from "../../utils/constants";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { Security } from "@verified-network/verified-sdk";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function RefundsModal(props) {
  let { snapShots } = props;
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    isUpdate,
    setIsUpdate,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [oldTime, setOldTime] = useState(null);
  const [newValue, newTime] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  // Fetching dates in future
  const currentDate = Math.floor(new Date().getTime() / 1000).toString();
  snapShots = snapShots.filter((date) => date > currentDate);

  const rescheduleSnapshot = async () => {
    newValue.setSeconds(0);
    let newTimeStamp = Math.floor(newValue.getTime() / 1000).toString();
    if (!oldTime) {
      toast.error(FailureToast("", "Select Old time"), ToastOptions);
      return;
    }
    if (!newValue) {
      toast.error(FailureToast("", "Select New time"), ToastOptions);
      return;
    }
    if (newValue && oldTime && newTimeStamp < oldTime) {
      toast.error(
        FailureToast("", "Select New time greater than Old time"),
        ToastOptions
      );
      return;
    }

    const securityTokenContract = new Security(signer, props.data.security);
    setLoading(true);
    let paymentToken;

    if (
      verifiedWalletDetails &&
      Object?.keys(verifiedWalletDetails)?.length > 0
    ) {
      const cashTokens = await getAllVerifiedCashBalances(
        chainId,
        web3,
        account
      );

      if (!cashTokens || cashTokens?.length === 0) {
        setLoading(false);
        toast.error(
          "No valid Cash Token on this network. Change network and try again.",
          ToastOptions
        );

        return;
      }
      paymentToken = cashTokens[0];
      const txQuote = await securityTokenContract._getMeeQuote(
        cashTokens[0]?.address,
        "rescheduleSnapshot",
        [oldTime?.toString(), newTimeStamp?.toString()]
      );

      if (
        Number(cashTokens[0]?.balance) === 0 ||
        Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
      ) {
        setLoading(false);
        toast.error(
          `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
          ToastOptions
        );

        return;
      }
    }
    try {
      await securityTokenContract
        .rescheduleSnapshot(
          oldTime?.toString(),
          newTimeStamp?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            setIsUpdate(!isUpdate);
            toast.success(SuccessToast(), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error(FailureToast(), ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      setLoading(false);
      toast.error(FailureToast(), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      {snapShots.length ? (
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Old Time</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title={
                    oldTime
                      ? format(
                          new Date(parseInt(oldTime) * 1000),
                          "yyyy-MM-dd hh:mm a"
                        )
                      : "Select Time"
                  }
                >
                  {snapShots?.map((date) => (
                    <Dropdown.Item onClick={(e) => setOldTime(date)}>
                      {format(
                        new Date(parseInt(date) * 1000),
                        "yyyy-MM-dd hh:mm a"
                      )}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>New Time</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <DateTimePicker onChange={newTime} value={newValue} />
              </Col>
            </Row>
            <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0">
                <UiButton
                  onClick={() => {
                    if (web3 && chainId && account && signer) {
                      rescheduleSnapshot();
                    }
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Reschedule"
                  type="submit"
                />
              </Col>
            </Row>
          </Row>
        </div>
      ) : (
        <p>No snapshots are scheduled</p>
      )}
    </>
  );
}

export function RescheduleSnapshot(props) {
  return <RefundsModal {...props} />;
}
